function setViewportUnit(): void {
  const root = document.documentElement;
  const viewport = window.visualViewport;
  const height = viewport ? viewport.height : window.innerHeight;
  if (!height) return;
  const unit = `${height * 0.01}px`;
  root.style.setProperty('--vh', unit);
}

export function initViewportUnits(): void {
  if (typeof window === 'undefined') {
    return;
  }

  setViewportUnit();

  window.addEventListener('resize', setViewportUnit);
  window.addEventListener('orientationchange', setViewportUnit);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', setViewportUnit);
    window.visualViewport.addEventListener('scroll', setViewportUnit);
  }
}
